import React from 'react'
import { menuItemParams } from '../../../types'
import style from './style.module.scss'
import clsx from 'clsx'

type mainHeaderParams = {
    menu: menuItemParams[]
    handleClick: (e: React.MouseEvent<HTMLElement>, id: number) => void
    external: string
    active: number | null
    isSearchOpen: boolean
    toggleSearch: () => void
}

const MenuMainHeader: React.FC<mainHeaderParams> = ({
    menu,
    handleClick,
    external,
    active,
    isSearchOpen,
    toggleSearch,
}) => {
    return (
        <nav className={style.nav}>
            <ul>
                {menu.map((item, index) => (
                    <li key={item.ID}>
                        <a
                            href={item.url}
                            target={item.target}
                            className={clsx(
                                index === active ? style.active : undefined,
                                item.classes,
                            )}
                            onClick={(e) =>
                                item.children?.length > 0 ? handleClick(e, index) : undefined
                            }
                        >
                            {item.title}
                        </a>
                    </li>
                ))}
                <li className={style.findClub}>
                    <a href={external} target={'_blank'} rel={'noreferrer'}>
                        trouver un club
                    </a>
                </li>
                <button className={style.search} onClick={toggleSearch} title="Recherche">
                    <i className={`fi fi-rs-${isSearchOpen ? 'cross' : 'search'}`} />
                </button>
            </ul>
        </nav>
    )
}

export default MenuMainHeader
